import { z } from 'zod';
import { HEIGHT, validPosition } from './movement';

const finite = z.number().finite();
export const vec3Schema = z.strictObject({ x: finite, y: finite, z: finite });
const box = z.strictObject({ min: vec3Schema, max: vec3Schema }).refine(b => b.min.x < b.max.x && b.min.y <= b.max.y && b.min.z < b.max.z);
export const mapSchema = z.strictObject({ bounds: box, spawn: vec3Schema, obstacles: z.array(box).max(128) });
export const environmentMapSchema = mapSchema.refine(map => {
  if (map.bounds.min.y > 0 || map.bounds.max.y < HEIGHT || !validPosition(map.spawn, map)) return false;
  return [map.bounds, ...map.obstacles].every(b => b.min.y < b.max.y && Object.values(b.min).every(n => n >= -64) && Object.values(b.max).every(n => n <= 64));
}, 'Invalid collision bounds or obstructed spawn');
